import { TextInputField } from 'components/Form/TextInputField'
import Styles from '../../../BlogMetadata.module.scss'

interface TitleFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const TitleField: React.FC<TitleFieldProps> = ({ value, onChange }) => (
  <TextInputField
    wrapperClassName={Styles.inputField}
    label="Title"
    value={value}
    onChange={onChange}
    size="lg"
    labelClassName={Styles.textFieldLabel}
  />
)
